module.exports = __webpack_public_path__ + "img/01b6b39.png";